import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import Buefy from 'buefy'
import vSelect from 'vue-select'
import { apolloProvider } from './apollo'
import CognitoPlugin from './plugins/cognito/cognitoPlugin'
import 'buefy/dist/buefy.css'

// import styles
import './style/style.scss'

// add Buefy - Bulma CSS support
Vue.use(Buefy)

// pipes for Moment.js
Vue.use(require('vue-moment'))

// add element for selecting tags
Vue.component('v-select', vSelect)

// add an Http client
Vue.prototype.$http = axios

// get the Cognito variables from the backend before starting the app
axios.get(process.env.VUE_APP_SETTINGS_URI).then((response) => {
  // extract the values
  const COGNITO_POOL_ID = response.data.COGNITO_POOL_ID
  const COGNITO_CLIENT_ID = response.data.COGNITO_CLIENT_ID
  // setup Cognito
  Vue.use(CognitoPlugin, {
    COGNITO_POOL_ID,
    COGNITO_CLIENT_ID
  })

  // create the app instance
  Vue.config.productionTip = false
  window.app = new Vue({
    router,
    apolloProvider,
    render: h => h(App)
  }).$mount('#app')
})
